<template>
  <div>
    <p v-if="visit.shipping_ids"><br>
      ID/s: <strong v-for="(id, index) in visit.shipping_ids" :key="index">
        <b-link :to="{name: 'ShippingsEdit', params: {id}}" target="_blank">{{ id }}</b-link>
        <a href="#" @click.prevent="copyToClipboard(id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a><span v-if="(index + 1) < visit.shipping_ids.length">, </span>
      </strong>
    </p>
    <h6 v-else>
      <span v-translate><strong>Shared</strong> Shipment</span>
    </h6>
    <div v-html="_createTourInfoWindow(visit, tour)"></div>
    <div v-if="tour.courier">
      <hr class="my-1">
      <user-card class="my-3" :user="tour.courier" :withMap="false" profilePictureSize="50px" :withTitles="false" />
    </div>
    <div>
      <div class="text-center">
        <b-button size="sm" variant="primary" @click="$root.$emit('data-selected', {...tour, ...{cardType: 'tour', normalize: true}})" v-translate>
          View Detail
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ShippingVisit from '@/components/Shippings/Visit'

export default {
  emits: ['delete-from-tour'],
  name: 'TourVisit',
  components: {
    ShippingVisit
  },
  props: {
    visit: {
      type: Object,
      required: true
    },
    tour: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    multi() {
      return this.visit.shipping_ids.length > 1
    },
    showDeleteButton() {
      return this.visit.visited !== true && !this.multi && this.tour.status !== 'FINISHED'
    }
  },
  mounted() {
    // console.log('tour', this.tour)
  },
  methods: {
    emitDeleteFromTour(id) {
      this.$emit('delete-from-tour', id)
    },
    _createTourInfoWindow(visit, item) {
      let html = '<p>' + this.$gettextInterpolate(this.$ngettext('Type: <strong>%{type}</strong><span class="d-none">%{n}</span>', 'Type: <strong>%{type} multiple (%{n} shippings)</strong>', visit.shipping_ids.length), { type: this.$gettext(visit.type), n: visit.shipping_ids.length }) + '</p>'
      html += '<p>' + this.$gettextInterpolate(this.$gettext('Address: <strong>%{address}</strong>'), { address: visit.address_name }) + '</p>'
      if (item.commissionRaw !== 0) {
        html += '<p>' + this.$gettextInterpolate(this.$gettext('Total Profit: <strong>%{commission}</strong>'), { commission: item.formatted_courier_commission }, true) + '</p>'
      }
      return html
    }
  }
}
</script>